import React from 'react';
import { Link } from 'react-router-dom';
import { CgFileDocument, CgGlobeAlt, CgDatabase } from "react-icons/cg";
import { FaPenToSquare } from "react-icons/fa6";
import "../introduction.css";

const Graphic = (props) => {
    const currentDate = new Date();
    let salutation = "";

    // Get local time as a string with locale
    const localTimeHour = parseInt(currentDate.toLocaleTimeString(navigator.language, {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
    }).split(":")[0]);

    if (localTimeHour < 12) {
        salutation = "Good Morning";
    }
    else if (localTimeHour < 16) {
        salutation = "Good Afternoon";
    }
    else {
        salutation = "Good Evening";
    }

    let positions = props.current.jobs.map((pos) => (<p>{pos.title} at {pos.company}, {pos.organization}</p>))

    let textAppear = async (texts, id) => {
        let loc = document.getElementById(id)
        let j = 0;

        while (j < texts.length) {
            let text = texts[j]
            let i = 0
            while (i < text.length) {
                loc.innerHTML = text.slice(0, i);
                i++;
                await delay(100);
            }
            await delay(1000);
            loc.innerHTML = " ";
            j++;
            j = j % texts.length;
        }
    }

    const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

    React.useEffect(() => {
        //textAppear(["Distributed Systems ", "DevOps & Cloud ", "Fullstack Engineering "], "specialization");
    },[])

    return (
        <div id='introduction_graphic'>
            <div id='intro_info'>
                <div className='right_container'>
                    <div className="tag" id="specialization">
                        <p><span>SPECIALIZING IN </span></p><b>dEVoPS & cLOUD, fULLSTACK eNGINEERING</b>
                    </div>
                    <div className="tag">
                        <p><span>PASSIONATE ABOUT </span></p><b>dATA, R&D and fINANCE.</b>
                    </div>
                </div>
                <div className='container'>
                    {/*<h1 className='smaller i_am'>
                        <div style={{fontSize: 40}}>
                            {salutation},
                        </div>
                    </h1>*/}
                    <h1 className='i_am'>
                        I AM
                    </h1>
                    <h1 className='i_am'>
                        ABHINANDAN SAHA.
                    </h1>
                    {[positions]}
                </div>
                <div className='container' id='intro_data'>
                    <div className='left_container'>
                        <div className='intro_buttons center' style={{justifyContent:"flex-start"}}>
                            <div onClick={() => {document.getElementById("me_contact").scrollIntoView()}} href="/" className='tab-7 center'>
                                <div className='tab_title'>
                                    <CgGlobeAlt  size={35}/>
                                </div>
                                <div className='me_button tab_description'>
                                    Network with Me
                                </div>
                            </div>
                            <div onClick={() => {document.getElementById("me_resume").scrollIntoView()}} href="/" className='tab-7 center'>
                                <div className='tab_title'>
                                    <CgFileDocument  size={35}/>
                                </div>
                                <div className='me_button tab_description'>
                                    Download C.V.
                                </div>
                            </div>
                        </div>
                        <div className='intro_buttons center' style={{justifyContent:"flex-start"}}>
                            <Link to="/projects" className='tab-7 center'>
                                <div className='tab_title'>
                                    <CgDatabase  size={35}/>
                                </div>
                                <div className='me_button tab_description'>
                                    View My Projects
                                </div>
                            </Link>
                            <Link to="/blog" className='tab-7 center'>
                                <div className='tab_title'>
                                    <FaPenToSquare  size={30}/>
                                </div>
                                <div className='me_button tab_description'>
                                    Read My Blog
                                </div>
                            </Link>
                        </div>
                        <div className='intro_p'>
                            {/*<span className='smaller'>{total_experience_duration}+ years</span> {props.catch.details}*/}
                            {props.current.catch.details}
                        </div>
                    </div>
                    
                </div>
            </div>
            <div id='profile_picture'>
                <img id="me_photo" src={process.env.PUBLIC_URL + "/assets/introduction/profile_picture.png"} />
            </div>
        </div>
    )
}

export default Graphic;